import React, { useEffect, useState } from 'react';
import { Card, Switch, Typography } from 'antd';
import { emojis } from 'utils/slackemojis';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { channelAdminConfig } from '../skills_action';
import queryString from 'query-string';

const InternalComment = (props) => {
  const { Text, Paragraph } = Typography;
  const dispatch = useDispatch();
  const [toggleComment, setToggleComment] = useState(false);
  const params = queryString.parse(props.location.search);
  const channelid = params.channel_id || props.channel_id || null;
  const commonChanneldata = useSelector(
    (state) => state?.skills?.commonChanneldata
  );
  const channelSettings = commonChanneldata.find(
    (channel) => channel.channel_id === channelid
  );

  useEffect(() => {
    setToggleComment(channelSettings?.enableInternalCommentInAgent);
  }, [channelSettings]);

  const handleToggleComment = (value) => {
    const skill_id = props.match.params.skill_id;
    const wId = props.match.params.wId;
    const data = {
      enableInternalCommentInAgent: value,
    };
    setToggleComment(value);

    dispatch(
      channelAdminConfig(
        wId,
        skill_id,
        channelid,
        data,
        props.isGridSharedChannel
      )
    );
  };

  return (
    <Card
      key={'1'}
      title='Internal comment by default'
      extra={
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Switch
            checked={toggleComment}
            onClick={() => {
              handleToggleComment(!toggleComment);
            }}
          />
        </div>
      }
    >
      <Paragraph type='secondary'>
        {`When syncing Slack messages with Jira, add them as internal comments by
        default. This is relevant when the discussion in Slack is primarily
        private to the help desk team. When the feature is enabled, use the
        :mega: ${emojis[':mega:']} emoji at the beginning of message in Slack to publish it as a
        public comment in Jira.`}
      </Paragraph>
      <div className='Jira_preference_personal_default_type'>
        <Text type='secondary'>
          This feature works only with supported JSM projects.
        </Text>
      </div>
    </Card>
  );
};

export default withRouter(InternalComment);
